/**
 * Prix d'appel "monture seule" par pays — utilisés à la fois par
 * PricesPage (bloc complet) et par CityPage (SEO + meta description).
 *
 * Source de vérité unique : évite les divergences entre pages.
 * Les valeurs sont en devise locale (XOF, UGX, MAD, USD…).
 */
export interface QuickPrices {
  frameOnly: number;
  packStart: number;
  optionsStart: number;
}

export const COUNTRY_QUICK_PRICES: Record<string, QuickPrices> = {
  "cote-divoire": { frameOnly: 10000, packStart: 19000, optionsStart: 10000 },
  mali: { frameOnly: 10000, packStart: 19000, optionsStart: 10000 },
  benin: { frameOnly: 10000, packStart: 19000, optionsStart: 10000 },
  "burkina-faso": { frameOnly: 10000, packStart: 19000, optionsStart: 10000 },
  cameroun: { frameOnly: 10000, packStart: 19000, optionsStart: 10000 },
  togo: { frameOnly: 10000, packStart: 19000, optionsStart: 10000 },
  senegal: { frameOnly: 10000, packStart: 19000, optionsStart: 10000 },
  uganda: { frameOnly: 80000, packStart: 105000, optionsStart: 50000 },
  maroc: { frameOnly: 300, packStart: 300, optionsStart: 150 },
  rdc: { frameOnly: 20, packStart: 45, optionsStart: 25 },
};

export function getQuickPrices(slug: string): QuickPrices | null {
  return COUNTRY_QUICK_PRICES[slug] ?? null;
}
